import { Typography, Chip, Skeleton } from '@mui/material'
import { FlexCol, FlexRow } from '../../../components/Flex'

import { CustomListItem } from '../../../components'
import { numberFormat } from '../../../utils'

interface Props {
  uid: string
  yyyymmdd: number
  credits: number
  type: string
}

const formatDate = (yyyymmdd: number): string => {
  const dateStr = yyyymmdd.toString()
  const year = dateStr.substring(0, 4)
  const month = dateStr.substring(4, 6)
  const day = dateStr.substring(6, 8)
  return `${month}/${day}/${year}`
}

const getTypeColor = (type: string): 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' => {
  switch (type) {
    case 'credit':
      return 'warning' // Weekly credits for losses
    case 'nft_bonus':
      return 'info' // Daily NFT bonus
    case 'nft_credit':
      return 'success' // Weekly NFT credits
    default:
      return 'primary'
  }
}

const getTypeLabel = (type: string): string => {
  switch (type) {
    case 'credit':
      return 'Weekly Loss Credit'
    case 'nft_bonus':
      return 'Daily NFT Bonus'
    case 'nft_credit':
      return 'Weekly NFT Credit'
    default:
      return type
  }
}

const GeoclaimCreditsItem: React.FC<React.PropsWithChildren<Props>> = ({ uid, yyyymmdd, credits, type }) => {
  const isLoading = type === 'loading'
  
  if (isLoading) {
    return (
      <CustomListItem>
        <FlexCol alignItems="flex-start" style={{ flex: 1 }}>
          <Skeleton variant="rectangular" width={140} height={24} sx={{ borderRadius: '16px', marginBottom: 0.5 }} />
          <Skeleton variant="text" width={100} height={24} />
        </FlexCol>
        <FlexCol alignItems="flex-end">
          <Skeleton variant="text" width={100} height={32} />
          <Skeleton variant="text" width={40} height={20} />
        </FlexCol>
      </CustomListItem>
    )
  }
  
  return (
    <CustomListItem>
      <FlexCol alignItems="flex-start" style={{ flex: 1 }}>
        <Chip 
          label={getTypeLabel(type)} 
          color={getTypeColor(type)} 
          size="small"
          sx={{ fontWeight: 600, marginBottom: 0.5 }}
        />
        <Typography variant="body1" color="textSecondary">
          {formatDate(yyyymmdd)}
        </Typography>
      </FlexCol>
      <FlexCol alignItems="flex-end">
        <Typography variant="h6" fontWeight="bold" color={credits > 0 ? 'success.main' : 'error.main'}>
          {credits > 0 ? '+' : ''}{numberFormat(credits)}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          COIN
        </Typography>
      </FlexCol>
    </CustomListItem>
  )
}

export default GeoclaimCreditsItem